import logo from "../assets/logo.png";
export default function Logo() {
  return <img src={logo} style={{ width: "4rem" }} alt="logo" />;
}
